import { BaseEntity } from "@bndes/bndes-ux4/bndes-angular-utils";

export class NaturezaJuridica extends BaseEntity {
  
    public idComplementoN02: number;
    public idN02: number;
    public nome: string;
    public restricaoTipoPessoa: string;


}
export enum Complemento {
    MenosUm = -1,
    Quatro = 4,
    Oito=8,
    Nove= 9,
    Dez= 10
}
  
  export const LabelRepasse = new Map<number, string>([
    [Complemento.MenosUm,'N/A'],
    [Complemento.Quatro,'4'],
    [Complemento.Oito,'8'],
    [Complemento.Nove,'9'],
    [Complemento.Dez,'10'],
   
   
  ])
  

  
